<template>
  <div id="app">
    <!-- <keep-alive :include="catch_components">
      <router-view></router-view>
</keep-alive> -->
  <keep-alive  >
  <router-view class="router_container" v-if="$route.meta.keepAlive"  :key="key"  ></router-view>
</keep-alive>
<router-view v-if="!$route.meta.keepAlive" :key="key" ></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data(){
    return{
      
    }
  },
  computed: {
     catch_components () {
       console.log(this.$store.state.user.catch_components)
      return this.$store.state.user.catch_components
    },
  key() {
    // return this.$key();
    return this.$route.path
  }
},
//  watch: {
//     getKeepAliveList (n, o) {
//       console.log(n)
//       this.keepAliveList = n
//     }
//   },
mounted(){
    
}
}
</script>

<style>
/* html,

body {

	width: 100%;

	height: 100%;

	overflow: hidden;

}

body {

	box-sizing: border-box;

	position: relative;

}


#app {
	width: 100%;
	height: 100%;
	overflow-y: auto;
} */
body.dialog-open{
  position: fixed;
  width: 100%;
}
.mint-toast{
  z-index: 9999;
}
*{
  -webkit-tap-highlight-color:rgba(255,255,255,0)
}
#app {
      position: relative;
  /* font-family: PingFangSC-Regular; */
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
}
*{
  padding:0px;
  margin:0px;
-webkit-text-size-adjust: none;
}

　　
input{
   outline:0px; 
}
input,textarea {
    outline: none;

}
html,body,#app{
height: 100%;
 user-select:none;
}
ul li{
  list-style: none;
}

.mint-msgbox{
      width: 282px!important;
    height: 120px!important;
}
.mint-msgbox-header {
  padding-top: 12px!important;
}
.mint-msgbox-content{
  padding: 16px!important;
  min-height: 20px!important;

}
.mint-msgbox-message{
      font-size: 14px;
    color: #666666;
  line-height: 20px!important;
}
.mint-msgbox-cancel{
  font-size: 12px!important;
    color: #666666!important;
}
.mint-msgbox-btns{
  height: 33px!important;
  line-height: 33px!important;
}
.mint-msgbox-btn{
   font-size: 12px!important;
  line-height: 33px!important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue